import React from "react";
import AgentLayout from "../components/AgentLayout";
const AgentBetfairGamesDashboard = () => {
    return (
        <AgentLayout>
            <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                <div class="card ExMainCardbundle">
                    <div className="card-body exlobbybg">
                        <div>
                            <div className="left">
                                <a href="/agent/hold">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg1.png"
                                                className="card-img-top"
                                                alt="Hold'em"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Hold'em</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/turbo-hold">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg2.jpg"
                                                className="card-img-top"
                                                alt="Turbo Hold'em"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Turbo Hold'em</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/blackjack">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg3.png"
                                                className="card-img-top"
                                                alt="BlackJack"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">BlackJack</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/turbo-blackjack">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg4.jpg"
                                                className="card-img-top"
                                                alt="Turbo BlackJack"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Turbo BlackJack</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/baccarat">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg5.jpg"
                                                className="card-img-top"
                                                alt="Baccarat"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Baccarat</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/turbo-baccarat">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg6.jpg"
                                                className="card-img-top"
                                                alt="Turbo Baccarat"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Turbo Baccarat</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/hilo">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg7.png"
                                                className="card-img-top"
                                                alt="Hi Lo"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Hi Lo</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/turbo-hilo">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg8.png"
                                                className="card-img-top"
                                                alt="Turbo HiLo"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Turbo HiLo</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/omaha-hi">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/bpimg9.jpg"
                                                className="card-img-top"
                                                alt="Omaha Hi"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Omaha Hi</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/derby-race">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/derby.jpg"
                                                className="card-img-top"
                                                alt="Derby Race"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Derby Race</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="left">
                                <a href="/agent/turbo-derby-race">
                                    <div className="card" style={{ marginBottom: "0px" }}>
                                        <div>
                                            <img
                                                src="/assets/images/bpstudio/derby-turbo-race.jpg"
                                                className="card-img-top"
                                                alt="Derby Race"
                                            />
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">Derby Turbo Race</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div
                        className="card-body mainexcard"
                        id="Excardbody"
                        style={{ display: "none" }}
                    ></div>
                </div>
            </div>
        </AgentLayout>
    );
};

export default AgentBetfairGamesDashboard;
